import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .then(() => console.log('Bootstrap OK'))
  .catch((err) => {
    console.error('Bootstrap falhou:', err);
    console.error('Causa raiz:', err.cause ?? err.ngOriginalError ?? 'sem causa');
  });
